// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const spinarak: PokeData = {
  "id": 167,
  "name": "spinarak",
  "height": 5,
  "weight": 85,
  "base_experience": 50,
  "types": [
    PokeType.BUG,
    PokeType.POISON
  ],
  "api_moves": [
    "poison-sting",
    "pin-missile",
    "absorb",
    "string-shot",
    "psychic",
    "agility",
    "night-shade",
    "screech",
    "constrict",
    "leech-life",
    "fury-swipes",
    "spider-web",
    "scary-face",
    "sucker-punch",
    "poison-jab",
    "shadow-sneak",
    "cross-poison",
    "sticky-web",
    "infestation",
    "toxic-thread"
  ],
  "moves": [
    "pin-missile",
    "string-shot",
    "psychic",
    "night-shade",
    "scary-face",
    "poison-jab",
    "shadow-sneak",
    "sticky-web",
    "acid-rain",
    "heal-order",
    "signal-spam",
    "sludge-bomb",
    "lunge"
  ],
  "evolution_chain": {
    "id": 85,
    "item": null,
    "species": [
      {
        "name": "spinarak",
        "order": 199,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ariados",
        "order": 200,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 167,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 40,
    "speed": 30,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
